let orderValue = "";
let ascending = true;

export default function orderArrayBy(arrayToOrder, orderBy, asc) {
  ascending = asc;
  orderValue = orderBy;
  arrayToOrder.sort(compare);
  return arrayToOrder;
}

function compare(a, b) {
  if (a[orderValue] < b[orderValue]) {
    return ascending ? -1 : 1;
  }
  if (a[orderValue] > b[orderValue]) {
    return ascending ? 1 : -1;
  }
  return 0;
}
